import { Loader } from "../Loader";

export const API_URL = `${process.env.REACT_APP_URL}/v1`;

export const usersLoader = new Loader(API_URL);
